import { Tooltip } from "@mui/material";

export default function CustomTooltip({ child, title }) {
    return (
        <Tooltip
            PopperProps={{
                modifiers: [
                    {
                        name: 'zIndex',
                        enabled: true,
                        phase: 'write',
                        fn({ state }) {
                            state.styles.popper.zIndex = 9999999;
                        },
                    },
                ],
            }}
            title={title}>
            {child}
        </Tooltip>
    )
}